export default "__VITE_ASSET__B2U6h2m4__"